import { Grid, Typography, Box } from "@mui/material";
import styles from './index.module.css';
import { formatPresentationDate } from "../../../utils/common";

const statusMap = {
  '1': 'Estimate', '1_sent': 'Estimate Sent', '2': 'Sales Order - Agreement',
  '2_sent': 'Sales Order - Agreement Sent', '3': 'Sales Order - Customer Signed', '4': 'Sales Order - Rejected',
};

const LOGO = 'https://elitepromomarketing.com/wp-content/uploads/2024/08/logo-1-600x183.png';
const DOCUMENT_BANNER = 'https://elitepromomarketing.com/wp-content/uploads/2025/08/elite-promo-marketing-document-header.png';

function getDocPrefix(status, forceEstimateView = false) {
  if (forceEstimateView) return 'Estimate #';
  const s = status == null ? '' : String(status);
  if (s === '1' || s === '1_sent' || s === '4') return 'Estimate #';
  if (s === '2' || s === '2_sent' || s === '3') return 'Sales Order #';
  return '';
}

const Header = ({ presentationDate, id, Introduction, status, headerConfig, isLoaded = false, isEstimateView = false }) => {
  const s = status == null ? '' : String(status);
  const prefix = getDocPrefix(s, isEstimateView);
  const statusLabel = statusMap[s] || '';
  const showMeta = Boolean(isLoaded && id && presentationDate);
  const resolvedLogo = headerConfig?.logoUrl || LOGO;
  const companyName = headerConfig?.companyName || 'Elite Promotional Marketing';
  const bannerUrl = headerConfig?.backgroundUrl || DOCUMENT_BANNER;
  const headerStyle = {
    backgroundImage: headerConfig?.backgroundUrl ? `url('${headerConfig.backgroundUrl}')` : undefined,
    backgroundColor: headerConfig?.backgroundColor || undefined,
  };

  return (
    <>
      <Grid container className={`${styles.headerContainer} ${styles.screenOnly}`} style={headerStyle}>
        {/* Use a real image for browser printing: background graphics can be disabled. */}
        <img src={bannerUrl} alt="" aria-hidden="true" className={styles.printBannerImage} />
        <Grid item xs={1.5} className={styles.headerLogoContainer}>
          <img src={resolvedLogo} className={styles.headerLogo} alt="Logo" />
        </Grid>
        <Grid item xs={5} className={styles.TitleContainer}>
          <Box className={styles.titleContent}>
            <Typography variant="h4" gutterBottom color="white">{companyName}</Typography>
            <Typography variant="body1" color="white" sx={{ visibility: showMeta ? 'visible' : 'hidden' }}>
              {prefix}{id}<br />{formatPresentationDate(presentationDate)} – Promotional Items
            </Typography>
            <Typography color="white">{Introduction}</Typography>
          </Box>
        </Grid>
      </Grid>

      <header className={styles.printOnly}>
        <div className={styles.printBrandRow}>
          <div className={styles.printLogoColumn}>
            <img src={resolvedLogo} alt={`${companyName} logo`} />
          </div>
          <div className={styles.printDocumentIdentity}>
            <h1>{companyName}</h1>
            <div>{prefix}{id || 'N/A'}</div>
            <div>{presentationDate ? `${formatPresentationDate(presentationDate)} – Promotional Items` : (statusLabel || 'Promotional Items')}</div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
